var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.template||_vm.page)?_c('h3',[_vm._v(_vm._s(_vm.isTemplate?_vm.template.name:_vm.page.name))]):_vm._e(),_c('div',[_vm._v("\n        风险监测页面内容\n    ")])])}
var staticRenderFns = []

export { render, staticRenderFns }